document.addEventListener("DOMContentLoaded", function () {

  const dataEl = document.getElementById("variant-desc-data");
  const container = document.getElementById("variant-desc");

  if (!dataEl || !container) return;

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch(e) {
    return;
  }

  function update() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput) return;

    const match = variants.find(v => String(v.id) === String(idInput.value));
    container.innerHTML = match ? match.desc : "";
  }

  // Init
  update();

  // Luister op variant wijziging
  document.addEventListener("change", function () {
    setTimeout(update, 0);
  });

});
